module.exports = __webpack_public_path__ + "static/media/alabama.6324d68a.svg";